import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthenticationManagerService } from '../../../../services/authentication-manager.service';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { AuthenticationRequest, AuthService, FormGroupErrorMessageComponent, LoadingPanelService, noWhitespaceValidator, Utils, TypeChecker } from 'lib-base';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import {IconFieldModule} from "primeng/iconfield";
import {InputIconModule} from "primeng/inputicon";
import {ToastModule} from "primeng/toast";

@Component({
  selector: 'app-login-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, FormGroupErrorMessageComponent, RecaptchaFormsModule, ButtonModule,
    TranslateModule, InputTextModule, PasswordModule, RecaptchaModule, IconFieldModule, InputIconModule, ToastModule],
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss'
})
export class LoginFormComponent implements OnInit {

  loginform !: FormGroup;
  private _translations: any = {};

  constructor(private _fb: FormBuilder, private _ms: MessageService, private _translate: TranslateService,
    private _as: AuthService, private _am: AuthenticationManagerService, private _lps: LoadingPanelService
  ) {
    this.InitializeLoginform();
  }

  ngOnInit() {
    this.translate();
  }

  private async translate(): Promise<void> {
    this._translations = await firstValueFrom(forkJoin({
      completeFields: this._translate.get('form.msg.complete-campos'),
      warnSummary: this._translate.get('form.msg.warn-summary'),
      errorSummary: this._translate.get('form.msg.error-summary'),
      tramitePendiente: this._translate.get('msg.tramitePendiente'),
      tareaPendiente: this._translate.get('msg.tareaPendiente'),
      continuar: this._translate.get('common.continuar')
    }));
  }

  InitializeLoginform() {
    this.loginform = this._fb.group({
      correo: [null, [Validators.required, noWhitespaceValidator, Validators.email]],
      password: [null, [Validators.required, noWhitespaceValidator]],
      recaptchaReactive: [null, [Validators.required]],
    });
  }

  onLoginFormSubmit(): void {
    if (this.loginform.invalid) {
      Utils.markAllFormControlsAsTouched(this.loginform);
      this._ms.add({ severity: 'warn', summary: this._translations.warnSummary, detail: this._translations.completeFields });
      return;
    }

    const request = {
      correo: this.loginform.get('correo')?.value,
      password: this.loginform.get('password')?.value,
      captchaToken: this.loginform.get('recaptchaReactive')?.value
    } as AuthenticationRequest;

    this.authenticate(request);
  }

  authenticate(request: AuthenticationRequest) {
    this._lps.show(true);
    this._as.authenticate(request).subscribe({
      next: (response) => {
        this._am.onMenuClose();
        this._lps.hide();
      },
      error: (error) => {
        if (error.error) {
          let parsedError = {} as any;
          if (typeof error.error === 'string') {
            parsedError = JSON.parse(error.error)
          } else if (TypeChecker.hasProperty(error.error, 'error') && TypeChecker.hasProperty(error.error, 'message')) {
            parsedError = error.error;
          }
          this._ms.add({ severity: 'error', summary: parsedError.error, detail: parsedError.message });
        } else {
          this._ms.add({ severity: 'error', summary: "HTTP Error", detail: error.message });
        }
      }
    });
  }



  onCancel() {
    this.loginform.reset();
    this._am.onMenuClose();
  }

  openTab(index: number) {
    this._am.onOpenTab(index);
  }

}
